"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NearbyMonuments$ = exports.NearbyMonuments$outboundSchema = exports.NearbyMonuments$inboundSchema = void 0;
exports.nearbyMonumentsToJSON = nearbyMonumentsToJSON;
exports.nearbyMonumentsFromJSON = nearbyMonumentsFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.NearbyMonuments$inboundSchema = z.object({
    distance_in_metres: z.nullable(z.number()),
    name: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "distance_in_metres": "distanceInMetres",
    });
});
/** @internal */
exports.NearbyMonuments$outboundSchema = z.object({
    distanceInMetres: z.nullable(z.number()),
    name: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        distanceInMetres: "distance_in_metres",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var NearbyMonuments$;
(function (NearbyMonuments$) {
    /** @deprecated use `NearbyMonuments$inboundSchema` instead. */
    NearbyMonuments$.inboundSchema = exports.NearbyMonuments$inboundSchema;
    /** @deprecated use `NearbyMonuments$outboundSchema` instead. */
    NearbyMonuments$.outboundSchema = exports.NearbyMonuments$outboundSchema;
})(NearbyMonuments$ || (exports.NearbyMonuments$ = NearbyMonuments$ = {}));
function nearbyMonumentsToJSON(nearbyMonuments) {
    return JSON.stringify(exports.NearbyMonuments$outboundSchema.parse(nearbyMonuments));
}
function nearbyMonumentsFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.NearbyMonuments$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'NearbyMonuments' from JSON`);
}
//# sourceMappingURL=nearbymonuments.js.map